import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getCategories } from "../../api";
import EnProductBoard from "./EnProducts";
import EnProductCatalog from "./EnProductCatalog";

const EnProductCategoryPage = () => {
  const { category: categoryParam } = useParams(); // en_name.toLowerCase() 값

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const res = await getCategories();
        setCategories(res.data.results ?? res.data);
        setLoading(false);
      } catch (err) {
        setError("Failed to load categories.");
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">{error}</div>;

  const currentCategory = categories.find(
    (c) => c.en_name.toLowerCase() === categoryParam
  );

  if (!currentCategory) {
    return <div className="error">Failed to load categories.</div>;
  }

  const siblingCategories = categories.filter((c) => c.order === currentCategory.order);

  return currentCategory.display_type === "catalog" ? (
    <EnProductCatalog category={currentCategory} siblings={siblingCategories} />
  ) : (
    <EnProductBoard category={currentCategory} siblings={siblingCategories} />
  );
};

export default EnProductCategoryPage;